<template>
    <v-text-field
        solo
        hide-details
        clearable
        label="Search"
        append-icon="mdi-magnify"
        v-bind:value="value"
        v-on:input="$emit('input', $event)"
        v-on:click:append="requestSearch"
        v-on:keydown.enter="requestSearch"
    ></v-text-field>
</template>

<script>
export default {
    props: {
        value: String
    },
    methods: {
        requestSearch() {
            this.$emit('request-search');
        }
    }
};
</script>
